import AdmissionsSvg from "./AdmissionsSvg";
import AgentsSvg from "./AgentsSvg";
import ApplicationsSvg from "./ApplicationsSvg";
import CancelSvg from "./CancelSvg";
import CheckboxCheckSvg from "./CheckboxCheckSvg";
import CheckboxUnCheckSvg from "./CheckboxUnCheckSvg";
import ChooseAllSvg from "./ChooseAllSvg";
import ClearAllSvg from "./ClearAllSvg";
import CustomizationLinesSvg from "./CustomizationLinesSvg";
import CustomizationSvg from "./CustomizationSvg";
import DatabaseSvg from "./DatabaseSvg";
import GuidelineSvg from "./GuidelineSvg";
import HomeSvg from "./HomeSvg";
import RecognitionSvg from "./RecognitionSvg";
import SaveSvg from "./SaveSvg";
import SendingMessagesSvg from "./SendingMessagesSvg";
import SupportSvg from "./SupportSvg";
import TaskSvg from "./TaskSvg";
import TeamSvg from "./TeamSvg";
import ViseSvg from "./ViseSvg";

export const SidebarSvgExportConst = {
  AdmissionsSvg,
  AgentsSvg,
  ApplicationsSvg,
  CancelSvg,
  CheckboxCheckSvg,
  CheckboxUnCheckSvg,
  ChooseAllSvg,
  ClearAllSvg,
  CustomizationLinesSvg,
  CustomizationSvg,
  DatabaseSvg,
  GuidelineSvg,
  HomeSvg,
  RecognitionSvg,
  SaveSvg,
  SendingMessagesSvg,
  SupportSvg,
  TaskSvg,
  TeamSvg,
  ViseSvg,
};
